/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TableTagRelationConnectionRepresentationFromJSON, TableTagRelationConnectionRepresentationToJSON, } from './';
export function AddConnectionsTableTagRelationRequestFromJSON(json) {
    return AddConnectionsTableTagRelationRequestFromJSONTyped(json, false);
}
export function AddConnectionsTableTagRelationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        connections: json['connections'].map(TableTagRelationConnectionRepresentationFromJSON),
    };
}
export function AddConnectionsTableTagRelationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        connections: value.connections.map(TableTagRelationConnectionRepresentationToJSON),
    };
}
